import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const META_PIXEL_ID = '724751383047419';

/**
 * Safely tracks a custom Meta pixel event.
 * @param {string} eventName - The name of the event (e.g., 'CompleteRegistration').
 * @param {object} [properties] - Optional properties for the event (e.g., { value: 100.00, currency: 'GBP' }).
 */
export const trackMetaEvent = (eventName, properties) => {
    if (typeof window.fbq === 'function') {
        window.fbq('track', eventName, properties);
        console.log(`[Meta Pixel] Tracked event: ${eventName}`, properties || '');
    } else {
        console.warn(`[Meta Pixel] fbq function not available. Cannot track ${eventName}.`);
    }
};

/**
 * Hook to track PageView events on route changes.
 * This is ONLY needed because the static PageView in index.html only fires once.
 * NOTE: We must still include the manual PageView event here because the
 * initialization is now separate in index.html, which fires the first one.
 * After the initial page load, we use this to fire PageView on route changes.
 */
export const useMetaPixelTracking = () => {
    const location = useLocation();
    
    // Tracks PageView on every route change (after the initial load handled by index.html)
    useEffect(() => {
        // We only track PageView on subsequent route changes, not on the initial mount
        // as the first PageView is handled by the script in index.html
        if (location.pathname) {
             // Since this hook is called after the initial script runs, we use a simple track.
            trackMetaEvent('PageView'); 
        }
    }, [location.pathname]);
};

// We still need the initialization function here for components that might rely on it,
// but the core initialization is handled by the index.html script.
export const initializeMetaPixel = () => {
    if (typeof window.fbq === 'function') {
        window.fbq('init', META_PIXEL_ID);
        console.log(`[Meta Pixel] Initialized: ${META_PIXEL_ID}`);
    } else {
        console.warn('[Meta Pixel] fbq function not available for initialization.');
    }
};

